export default __webpack_public_path__ + "static/media/youtube-icon.1645c50f.svg";